import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import { urls, copy, currentLang } from "../../shared/seo/links";
import {
  hasProfilePhoto,
  initials,
  lawyerAddress,
  lawyerGovernorate,
  lawyerName,
  lawyerState,
} from "./lawyerHelpers";
import "./lawyers.css";

// Profile header: breadcrumbs, photo, name, bar level and office location.
export default function LawyerProfileCard(props) {
  const Lng = currentLang();
  const { t } = useTranslation();
  const lawyer = props.lawyer;
  const name = lawyerName(lawyer, Lng);
  const state = lawyerState(lawyer, Lng);
  const governorate = lawyerGovernorate(lawyer);
  const text = copy.lawyer(Lng, lawyer);
  const [photoFailed, setPhotoFailed] = useState(false);
  const cityPath = governorate ? urls.lawyersPath(Lng, { governorate }) : null;

  return (
    <section className="avc-page-hero avc-profile-hero">
      <div className="container avc-page-hero__inner avc-profile-hero__inner">
        <nav className="avc-breadcrumbs" aria-label={t("breadcrumb_label")}>
          <ol>
            <li>
              <a href={urls.toHref(urls.homePath(Lng))}>{t("Home")}</a>
            </li>
            <li>
              <PathLink to={urls.lawyersPath(Lng)}>{t("Lawyers")}</PathLink>
            </li>
            {cityPath && (
              <li>
                <PathLink to={cityPath}>{state}</PathLink>
              </li>
            )}
            <li aria-current="page">{name}</li>
          </ol>
        </nav>
        <div className="avc-profile-hero__identity">
          <div className="avc-profile-hero__avatar">
            {hasProfilePhoto(lawyer) && !photoFailed ? (
              <img src={lawyer.profilePicture} alt={name} onError={() => setPhotoFailed(true)} />
            ) : (
              <span aria-hidden="true">{initials(name)}</span>
            )}
          </div>
          <div className="avc-profile-hero__text">
            <span className="avc-eyebrow">
              <i className="fas fa-balance-scale" aria-hidden="true"></i>
              {text.levelLabel}
            </span>
            <h1 className="avc-profile-hero__name">{text.h1}</h1>
            {state &&
              (cityPath ? (
                <PathLink to={cityPath} className="avc-profile-hero__location">
                  <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
                  <span>
                    <strong>{state}</strong>
                    {lawyerAddress(lawyer, Lng) ? " · " + lawyerAddress(lawyer, Lng) : ""}
                  </span>
                </PathLink>
              ) : (
                <span className="avc-profile-hero__location">
                  <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
                  <span>
                    <strong>{state}</strong>
                  </span>
                </span>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
